import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import {
  FlexRow,
  FlexRowSpaced,
  FlexRowWithFlow,
} from "../../../../../Common/Styles";
import { usePostCardContext } from "../PostCardContent";

export const Topics = () => {
  const { Color, typography } = useTheme();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const { postId } = usePostCardContext();

  if (!postId) return null;
  const original_post = processed_posts[postId];
  const topics = original_post.topics;
  if (!topics || !topics.length) return null;

  return (
    <Container>
      <FlexRow $gapInPx={8}>
        <Components.Text
          text="Topics"
          style={{ tokenStyle: typography.Body.M }}
          color={Color.text["text-emphasize-purple"].value}
          fontWeight="font-weight-semibold"
        />
        <FlexRowWithFlow $gapInPx={4}>
          {topics.map((topic, index) => (
            <Components.Pill
              key={`${topic}-${index}`}
              text={topic.name}
              showCloseIcon={false}
            />
          ))}
        </FlexRowWithFlow>
      </FlexRow>

      <IconContainer>
        <Components.Tooltip type="label" label="Tooltip needs to be added">
          <Components.Icon
            type="Info"
            color={Color.text["text-emphasize-purple"].value}
            size="16px"
          />
        </Components.Tooltip>
      </IconContainer>
    </Container>
  );
};

const Container = styled(FlexRowSpaced)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
const IconContainer = styled.div`
  padding-top: 4px;
`;
